<div class="boxed-content">
  <header i18n>Additional Information</header>
  <div class="boxed-content__container">
    <h4><span i18n>Is property managed by CBRE?</span> <span class="required">*</span></h4>
    <div class="radio-container" fxLayout="row wrap">
      <div fxFlex="10">
        <mat-radio-button
          class="represented-radio-yes"
          id="represented-radio-yes-{{index}}"
          name="represented-radio-yes-{{index}}"
          [checked]="property?.managed_by_cbre === true"
          (change)="radioSelected($event.value)"
          [value]="true" i18n
          color="primary">yes</mat-radio-button>
      </div>
      <div fxFlex="10">
        <mat-radio-button
          class="represented-radio-no"
          id="represented-radio-no-{{index}}"
          name="represented-radio-no-{{index}}"
          [checked]="property?.managed_by_cbre === false"
          (change)="radioSelected($event.value)"
          [value]="false" i18n
          color="primary">no</mat-radio-button>
      </div>
      <div fxFlex="80"></div>
    </div>
  </div>
</div>
